import { useEffect } from "react";

// global ref-count so multiple consumers (navbar, modals, etc.) can
// independently lock scroll without stepping on each other
let lockCount = 0;

function lock() {
  lockCount++;
  if (lockCount === 1) document.body.style.overflow = "hidden";
}

function unlock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) document.body.style.overflow = "";
}

export default function useDisableScrolling(active = true): void {
  useEffect(() => {
    if (!active) return;
    lock();
    return () => unlock();
  }, [active]);
}
